export const concatenateClassNames = (classNames, classes) => {
	let convertedClassNames = [];
	if (classes) {
		if (Array.isArray(classNames)) {
			classNames.forEach(name => convertedClassNames.push(classes[name]));
		} else {
			convertedClassNames.push(classes[classNames]);
		}
	}
	return convertedClassNames.join(' ');
};
